import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { AuthenticationService } from "../../../services/authentication/authentication.service";

@Component({
	selector: 'editor-display',
	inputs:['html'],
	templateUrl: './editor-display.component.html',
	styleUrls: ['./editor-display.component.css']
})
export class EditorDisplayComponent implements OnInit {
	html:string;
	url: SafeResourceUrl;
	constructor(
		private authenticationService: AuthenticationService,
		private sanitizer: DomSanitizer) {
	}
	ngOnInit() {
		
		
	}

}



// WEBPACK FOOTER //
// ./src/app/components/utility/editor-display/editor-display.component.ts